import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex",
  style: {"box-shadow":"0 0 15px rgba(0, 0, 0, 0.161)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:tabindex',5))),
      class: _normalizeClass([_ctx.getClass(_ctx.tabindex===5), "tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"])
    }, [
      _cache[12] || (_cache[12] = _createElementVNode("i", { class: "icon-occhio w-4 text-[12px]" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode("Campi")
        ])),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleExpand'))),
      class: "tooltip-activator bg-white py-2 px-7 hover:text-next-orange relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"
    }, [
      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "icon-freccia_diagonale h-4" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode("Espandi/Collassa")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:tabindex',0))),
      class: _normalizeClass([_ctx.getClass(_ctx.tabindex===0), "tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"])
    }, [
      _cache[16] || (_cache[16] = _createElementVNode("i", { class: "icon-info h-4" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [
          _createTextVNode("Info Sottoprogetto")
        ])),
        _: 1
      })
    ], 2),
    _createVNode(_component_router_link, {
      to: {name: 'VersioniSottoProgetto', params:{id: _ctx.id}},
      class: "tooltip-activator bg-white py-2 px-7 hover:text-next-orange relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"
    }, {
      default: _withCtx(() => [
        _cache[18] || (_cache[18] = _createElementVNode("i", { class: "icon-orologio_freccia h-4" }, null, -1)),
        _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode("Versioni")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:tabindex',1))),
      class: _normalizeClass([_ctx.getClass(_ctx.tabindex===1), "tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"])
    }, [
      _cache[20] || (_cache[20] = _createElementVNode("i", { class: "icon-flag h-4" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[19] || (_cache[19] = [
          _createTextVNode("Versione manuale")
        ])),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:tabindex',2))),
      class: _normalizeClass([_ctx.getClass(_ctx.tabindex===2), "tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"])
    }, [
      _cache[22] || (_cache[22] = _createElementVNode("i", { class: "rotate-180 icon-upload h-4" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [
          _createTextVNode("Esporta")
        ])),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:tabindex',3))),
      class: _normalizeClass([_ctx.getClass(_ctx.tabindex===3), "tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"])
    }, [
      _cache[24] || (_cache[24] = _createElementVNode("i", { class: "icon-calcolatrice h-4" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[23] || (_cache[23] = [
          _createTextVNode("Fee/Rebate/Markup")
        ])),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:tabindex',4))),
      class: _normalizeClass([_ctx.getClass(_ctx.tabindex===4), "tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"])
    }, [
      _cache[26] || (_cache[26] = _createElementVNode("i", { class: "icon-euro_frecce h-4" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[25] || (_cache[25] = [
          _createTextVNode("Valute")
        ])),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:tabindex',7))),
      class: _normalizeClass([_ctx.getClass(_ctx.tabindex===7), "tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"])
    }, [
      _cache[28] || (_cache[28] = _createElementVNode("i", { class: "icon-upload h-4" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[27] || (_cache[27] = [
          _createTextVNode("Importa")
        ])),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:tabindex',8))),
      class: _normalizeClass([_ctx.getClass(_ctx.tabindex===8), "tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"])
    }, [
      _cache[30] || (_cache[30] = _createElementVNode("i", { class: "icon-filtri h-4" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[29] || (_cache[29] = [
          _createTextVNode("Info policy")
        ])),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:tabindex',9))),
      class: _normalizeClass([_ctx.getClass(_ctx.tabindex===9), "tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark"])
    }, [
      _cache[32] || (_cache[32] = _createElementVNode("i", { class: "icon-tre_rettangoli h-4" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[31] || (_cache[31] = [
          _createTextVNode("Sconto")
        ])),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update:tabindex',6))),
      class: _normalizeClass([_ctx.getClass(_ctx.tabindex===6), "tooltip-activator bg-white py-2 px-7 hover:text-next-orange relative flex items-center justify-center cursor-pointer"])
    }, [
      _cache[34] || (_cache[34] = _createElementVNode("i", { class: "icon-biforcazione h-4" }, null, -1)),
      _createVNode(_component_Tooltip, { class: "-translate-y-1" }, {
        default: _withCtx(() => _cache[33] || (_cache[33] = [
          _createTextVNode("Storico vendite")
        ])),
        _: 1
      })
    ], 2)
  ]))
}